//@flow
import React from "react";
//$FlowFixMe
import css from "./menu.module.scss";
import openExternalLink from "./../lib/externallink";

const Menu = (): Object => {
  return (
    <div className={css.menu}>
      <div onClick={() => openExternalLink("https://indemandradio.com/liverpool/whatson")}>what's on</div>
      <Spacer/>
      <div onClick={() => openExternalLink("https://indemandradio.com/liverpool/shows")}>listen again</div>
    </div>
  );
};

const Spacer = ()=>{
  return <div className={css.spacer}>•</div>
}
export default Menu;
